{
  "0": 48,
  "1": 49,
  "2": 50,
  "3": 51,
  "4": 52,
  "5": 53,
  "6": 54,
  "7": 55,
  "8": 56,
  "9": 57,
  "fill-drip": 62838,
  "arrows-to-circle": 58557,
  "circle-chevron-right": 61752,
  "chevron-circle-right": 61752,
  "at": 64,
  "trash-can": 62189,
  "trash-alt": 62189,
  "text-height": 61492,
  "user-xmark": 62005,
  "user-times": 62005,
  "stethoscope": 61681,
  "message": 62074,
  "comment-alt": 62074,
  "info": 61737,
  "down-left-and-up-right-to-center": 62498,
  "compress-alt": 62498,
  "explosion": 58601,
  "file-lines": 61788,
  "file-alt": 61788,
  "file-text": 61788,
  "wave-square": 63550,
  "ring": 63243,
  "building-un": 58585,
  "dice-three": 62759,
  "calendar-days": 61555,
  "calendar-alt": 61555,
  "anchor-circle-check": 58538,
  "building-circle-arrow-right": 58577,
  "volleyball": 62559,
  "volleyball-ball": 62559,
  "arrows-up-to-line": 58562,
  "sort-down": 61661,
  "sort-desc": 61661,
  "circle-minus": 61526,
  "minus-circle": 61526,
  "door-open": 62763,
  "right-from-bracket": 62197,
  "sign-out-alt": 62197,
  "atom": 62930,
  "soap": 57454,
  "icons": 63597,
  "heart-music-camera-bolt": 63597,
  "microphone-lines-slash": 62777,
  "microphone-alt-slash": 62777,
  "bridge-circle-check": 58569,
  "pump-medical": 57450,
  "fingerprint": 62839,
  "hand-point-right": 61604,
  "magnifying-glass-location": 63113,
  "search-location": 63113,
  "forward-step": 61521,
  "step-forward": 61521,
  "face-smile-beam": 62904,
  "smile-beam": 62904,
  "flag-checkered": 61726,
  "football": 62542,
  "football-ball": 62542,
  "school-circle-exclamation": 58732,
  "crop": 61733,
  "angles-down": 61699,
  "angle-double-down": 61699,
  "users-rectangle": 58772,
  "people-roof": 58679,
  "people-line": 58676,
  "beer-mug-empty": 61692,
  "beer": 61692,
  "diagram-predecessor": 58487,
  "arrow-up-long": 61814,
  "long-arrow-up": 61814,
  "fire-flame-simple": 62570,
  "burn": 62570,
  "person": 61827,
  "male": 61827,
  "laptop": 61705,
  "file-csv": 63197,
  "menorah": 63094,
  "truck-plane": 58767,
  "record-vinyl": 63705,
  "face-grin-stars": 62855,
  "grin-stars": 62855,
  "bong": 62812,
  "spaghetti-monster-flying": 63099,
  "pastafarianism": 63099,
  "arrow-down-up-across-line": 58543,
  "spoon": 62181,
  "utensil-spoon": 62181,
  "jar-wheat": 58647,
  "envelopes-bulk": 63092,
  "mail-bulk": 63092,
  "file-circle-exclamation": 58603,
  "circle-h": 62590,
  "hospital-symbol": 62590,
  "pager": 63509,
  "address-book": 62137,
  "contact-book": 62137,
  "strikethrough": 61644,
  "k": 75,
  "landmark-flag": 58652,
  "pencil": 62211,
  "pencil-alt": 62211,
  "backward": 61514,
  "caret-right": 61658,
  "comments": 61574,
  "paste": 61674,
  "file-clipboard": 61674,
  "code-pull-request": 57660,
  "clipboard-list": 62573,
  "truck-ramp-box": 62686,
  "truck-loading": 62686,
  "user-check": 62716,
  "vial-virus": 58775,
  "sheet-plastic": 58737,
  "blog": 63361,
  "user-ninja": 62724,
  "person-arrow-up-from-line": 58681,
  "scroll-torah": 63136,
  "torah": 63136,
  "broom-ball": 62552,
  "quidditch": 62552,
  "quidditch-broom-ball": 62552,
  "toggle-off": 61956,
  "box-archive": 61831,
  "archive": 61831,
  "person-drowning": 58693,
  "arrow-down-9-1": 63622,
  "sort-numeric-desc": 63622,
  "sort-numeric-down-alt": 63622,
  "face-grin-tongue-squint": 62858,
  "grin-tongue-squint": 62858,
  "spray-can": 62909,
  "truck-monster": 63035,
  "w": 87,
  "earth-africa": 62844,
  "globe-africa": 62844,
  "rainbow": 63323,
  "circle-notch": 61902,
  "tablet-screen-button": 62458,
  "tablet-alt": 62458,
  "paw": 61872,
  "cloud": 61634,
  "trowel-bricks": 58762,
  "face-flushed": 62841,
  "flushed": 62841,
  "hospital-user": 63501,
  "tent-arrow-left-right": 58751,
  "gavel": 61667,
  "legal": 61667,
  "binoculars": 61925,
  "microphone-slash": 61745,
  "box-tissue": 57435,
  "motorcycle": 61980,
  "bell-concierge": 62818,
  "concierge-bell": 62818,
  "pen-ruler": 62894,
  "pencil-ruler": 62894,
  "people-arrows": 57448,
  "people-arrows-left-right": 57448,
  "mars-and-venus-burst": 58659,
  "square-caret-right": 61778,
  "caret-square-right": 61778,
  "scissors": 61636,
  "cut": 61636,
  "sun-plant-wilt": 58746,
  "toilets-portable": 58756,
  "hockey-puck": 62547,
  "table": 61646,
  "magnifying-glass-arrow-right": 58657,
  "tachograph-digital": 62822,
  "digital-tachograph": 62822,
  "users-slash": 57459,
  "clover": 57657,
  "reply": 62437,
  "mail-reply": 62437,
  "star-and-crescent": 63129,
  "house-fire": 58636,
  "square-minus": 61766,
  "minus-square": 61766,
  "helicopter": 62771,
  "compass": 61774,
  "square-caret-down": 61776,
  "caret-square-down": 61776,
  "file-circle-question": 58607,
  "laptop-code": 62972,
  "swatchbook": 62915,
  "prescription-bottle": 62597,
  "bars": 61641,
  "navicon": 61641,
  "people-group": 58675,
  "hourglass-end": 62035,
  "hourglass-3": 62035,
  "heart-crack": 63401,
  "heart-broken": 63401,
  "square-up-right": 62304,
  "external-link-square-alt": 62304,
  "face-kiss-beam": 62871,
  "kiss-beam": 62871,
  "film": 61448,
  "ruler-horizontal": 62791,
  "people-robbery": 58678,
  "lightbulb": 61675,
  "caret-left": 61657,
  "circle-exclamation": 61546,
  "exclamation-circle": 61546,
  "school-circle-xmark": 58733,
  "arrow-right-from-bracket": 61579,
  "sign-out": 61579,
  "circle-chevron-down": 61754,
  "chevron-circle-down": 61754,
  "unlock-keyhole": 61758,
  "unlock-alt": 61758,
  "cloud-showers-heavy": 63296,
  "headphones-simple": 62863,
  "headphones-alt": 62863,
  "sitemap": 61672,
  "circle-dollar-to-slot": 62649,
  "donate": 62649,
  "memory": 62776,
  "road-spikes": 58728,
  "fire-burner": 58609,
  "flag": 61476,
  "hanukiah": 63206,
  "feather": 62765,
  "volume-low": 61479,
  "volume-down": 61479,
  "comment-slash": 62643,
  "cloud-sun-rain": 63299,
  "compress": 61542,
  "wheat-awn": 58061,
  "wheat-alt": 58061,
  "ankh": 63044,
  "hands-holding-child": 58618,
  "asterisk": 42,
  "square-check": 61770,
  "check-square": 61770,
  "peseta-sign": 57889,
  "heading": 61916,
  "header": 61916,
  "ghost": 63202,
  "list": 61498,
  "list-squares": 61498,
  "square-phone-flip": 63611,
  "phone-square-alt": 63611,
  "cart-plus": 61975,
  "gamepad": 61723,
  "circle-dot": 61842,
  "dot-circle": 61842,
  "face-dizzy": 62823,
  "dizzy": 62823,
  "egg": 63483,
  "house-medical-circle-xmark": 58643,
  "campground": 63163,
  "folder-plus": 63070,
  "futbol": 61923,
  "futbol-ball": 61923,
  "soccer-ball": 61923,
  "paintbrush": 61948,
  "paint-brush": 61948,
  "lock": 61475,
  "gas-pump": 62767,
  "hot-tub-person": 62867,
  "hot-tub": 62867,
  "map-location": 62879,
  "map-marked": 62879,
  "house-flood-water": 58638,
  "tree": 61883,
  "bridge-lock": 58572,
  "sack-dollar": 63517,
  "pen-to-square": 61508,
  "edit": 61508,
  "car-side": 62948,
  "share-nodes": 61920,
  "share-alt": 61920,
  "heart-circle-minus": 58623,
  "hourglass-half": 62034,
  "hourglass-2": 62034,
  "microscope": 62992,
  "sink": 57453,
  "bag-shopping": 62096,
  "shopping-bag": 62096,
  "arrow-down-z-a": 63617,
  "sort-alpha-desc": 63617,
  "sort-alpha-down-alt": 63617,
  "mitten": 63413,
  "person-rays": 58701,
  "users": 61632,
  "eye-slash": 61552,
  "flask-vial": 58611,
  "hand": 62038,
  "hand-paper": 62038,
  "om": 63097,
  "worm": 58777,
  "house-circle-xmark": 58635,
  "plug": 61926,
  "chevron-up": 61559,
  "hand-spock": 62041,
  "stopwatch": 62194,
  "face-kiss": 62870,
  "kiss": 62870,
  "bridge-circle-xmark": 58571,
  "face-grin-tongue": 62857,
  "grin-tongue": 62857,
  "chess-bishop": 62522,
  "face-grin-wink": 62860,
  "grin-wink": 62860,
  "ear-deaf": 62116,
  "deaf": 62116,
  "deafness": 62116,
  "hard-of-hearing": 62116,
  "road-circle-check": 58724,
  "dice-five": 62755,
  "square-rss": 61763,
  "rss-square": 61763,
  "land-mine-on": 58651,
  "i-cursor": 62022,
  "stamp": 62911,
  "stairs": 57993,
  "i": 73,
  "hryvnia-sign": 63218,
  "hryvnia": 63218,
  "pills": 62596,
  "face-grin-wide": 62849,
  "grin-alt": 62849,
  "tooth": 62921,
  "v": 86,
  "bangladeshi-taka-sign": 58086,
  "bicycle": 61958,
  "staff-snake": 58745,
  "rod-asclepius": 58745,
  "rod-snake": 58745,
  "staff-aesculapius": 58745,
  "head-side-cough-slash": 57442,
  "truck-medical": 61689,
  "ambulance": 61689,
  "wheat-awn-circle-exclamation": 58776,
  "snowman": 63440,
  "mortar-pestle": 62887,
  "road-barrier": 58722,
  "school": 62793,
  "igloo": 63406,
  "joint": 62869,
  "angle-right": 61701,
  "horse": 63216,
  "q": 81,
  "g": 71,
  "notes-medical": 62593,
  "temperature-half": 62153,
  "temperature-2": 62153,
  "thermometer-2": 62153,
  "thermometer-half": 62153,
  "dong-sign": 57705,
  "capsules": 62571,
  "poo-storm": 63322,
  "poo-bolt": 63322,
  "face-frown-open": 62842,
  "frown-open": 62842,
  "hand-point-up": 61606,
  "money-bill": 61654,
  "bookmark": 61486,
  "align-justify": 61497,
  "umbrella-beach": 62922,
  "helmet-un": 58627,
  "bullseye": 61760,
  "bacon": 63461,
  "hand-point-down": 61607,
  "arrow-up-from-bracket": 57498,
  "folder": 61563,
  "folder-blank": 61563,
  "file-waveform": 62584,
  "file-medical-alt": 62584,
  "radiation": 63417,
  "chart-simple": 58483,
  "mars-stroke": 61993,
  "vial": 62610,
  "gauge": 63012,
  "dashboard": 63012,
  "gauge-med": 63012,
  "tachometer-alt-average": 63012,
  "wand-magic-sparkles": 58058,
  "magic-wand-sparkles": 58058,
  "e": 69,
  "pen-clip": 62213,
  "pen-alt": 62213,
  "bridge-circle-exclamation": 58570,
  "user": 61447,
  "school-circle-check": 58731,
  "dumpster": 63379,
  "van-shuttle": 62902,
  "shuttle-van": 62902,
  "building-user": 58586,
  "square-caret-left": 61841,
  "caret-square-left": 61841,
  "highlighter": 62865,
  "key": 61572,
  "bullhorn": 61601,
  "globe": 61612,
  "synagogue": 63131,
  "person-half-dress": 58696,
  "road-bridge": 58723,
  "location-arrow": 61732,
  "c": 67,
  "tablet-button": 61706,
  "building-lock": 58582,
  "pizza-slice": 63512,
  "money-bill-wave": 62778,
  "chart-area": 61950,
  "area-chart": 61950,
  "house-flag": 58637,
  "person-circle-minus": 58688,
  "ban": 61534,
  "cancel": 61534,
  "camera-rotate": 57560,
  "spray-can-sparkles": 62928,
  "air-freshener": 62928,
  "star": 61445,
  "repeat": 62307,
  "cross": 63060,
  "box": 62566,
  "venus-mars": 61992,
  "arrow-pointer": 62021,
  "mouse-pointer": 62021,
  "maximize": 62238,
  "expand-arrows-alt": 62238,
  "charging-station": 62951,
  "shapes": 63007,
  "triangle-circle-square": 63007,
  "shuffle": 61556,
  "random": 61556,
  "person-running": 63244,
  "running": 63244,
  "mobile-retro": 58663,
  "grip-lines-vertical": 63397,
  "spider": 63255,
  "hands-bound": 58617,
  "file-invoice-dollar": 62833,
  "plane-circle-exclamation": 58710,
  "x-ray": 62615,
  "spell-check": 63633,
  "slash": 63253,
  "computer-mouse": 63692,
  "mouse": 63692,
  "arrow-right-to-bracket": 61584,
  "sign-in": 61584,
  "shop-slash": 57456,
  "store-alt-slash": 57456,
  "server": 62003,
  "virus-covid-slash": 58537,
  "shop-lock": 58533,
  "hourglass-start": 62033,
  "hourglass-1": 62033,
  "blender-phone": 63158,
  "building-wheat": 58587,
  "person-breastfeeding": 58682,
  "right-to-bracket": 62198,
  "sign-in-alt": 62198,
  "venus": 61985,
  "passport": 62891,
  "thumbtack-slash": 59023,
  "thumb-tack-slash": 59023,
  "heart-pulse": 61982,
  "heartbeat": 61982,
  "people-carry-box": 62670,
  "people-carry": 62670,
  "temperature-high": 63337,
  "microchip": 62171,
  "crown": 62753,
  "weight-hanging": 62925,
  "xmarks-lines": 58778,
  "file-prescription": 62834,
  "weight-scale": 62614,
  "weight": 62614,
  "user-group": 62720,
  "user-friends": 62720,
  "arrow-up-a-z": 61790,
  "sort-alpha-up": 61790,
  "chess-knight": 62529,
  "face-laugh-squint": 62875,
  "laugh-squint": 62875,
  "wheelchair": 61843,
  "circle-arrow-up": 61610,
  "arrow-circle-up": 61610,
  "toggle-on": 61957,
  "person-walking": 62804,
  "walking": 62804,
  "l": 76,
  "fire": 61549,
  "bed-pulse": 62599,
  "procedures": 62599,
  "shuttle-space": 61847,
  "space-shuttle": 61847,
  "face-laugh": 62873,
  "laugh": 62873,
  "folder-open": 61564,
  "heart-circle-plus": 58624,
  "code-fork": 57659,
  "city": 63055,
  "microphone-lines": 62409,
  "microphone-alt": 62409,
  "pepper-hot": 63510,
  "unlock": 61596,
  "colon-sign": 57664,
  "headset": 62864,
  "store-slash": 57457,
  "road-circle-xmark": 58726,
  "user-minus": 62723,
  "mars-stroke-up": 61994,
  "mars-stroke-v": 61994,
  "champagne-glasses": 63391,
  "glass-cheers": 63391,
  "clipboard": 62248,
  "house-circle-exclamation": 58634,
  "file-arrow-up": 62836,
  "file-upload": 62836,
  "wifi": 61931,
  "wifi-3": 61931,
  "wifi-strong": 61931,
  "bath": 62157,
  "bathtub": 62157,
  "underline": 61645,
  "user-pen": 62719,
  "user-edit": 62719,
  "signature": 62903,
  "stroopwafel": 62801,
  "bold": 61490,
  "anchor-lock": 58541,
  "building-ngo": 58583,
  "manat-sign": 57813,
  "not-equal": 62782,
  "border-top-left": 63571,
  "border-style": 63571,
  "map-location-dot": 62880,
  "map-marked-alt": 62880,
  "jedi": 63081,
  "square-poll-vertical": 63105,
  "poll": 63105,
  "mug-hot": 63414,
  "car-battery": 62943,
  "battery-car": 62943,
  "gift": 61547,
  "dice-two": 62760,
  "chess-queen": 62533,
  "glasses": 62768,
  "chess-board": 62524,
  "building-circle-check": 58578,
  "person-chalkboard": 58685,
  "mars-stroke-right": 61995,
  "mars-stroke-h": 61995,
  "hand-back-fist": 62037,
  "hand-rock": 62037,
  "square-caret-up": 61777,
  "caret-square-up": 61777,
  "cloud-showers-water": 58596,
  "chart-bar": 61568,
  "bar-chart": 61568,
  "hands-bubbles": 57438,
  "hands-wash": 57438,
  "less-than-equal": 62775,
  "train": 62008,
  "eye-low-vision": 62120,
  "low-vision": 62120,
  "crow": 62752,
  "sailboat": 58437,
  "window-restore": 62162,
  "square-plus": 61694,
  "plus-square": 61694,
  "torii-gate": 63137,
  "frog": 62766,
  "bucket": 58575,
  "image": 61502,
  "microphone": 61744,
  "cow": 63176,
  "caret-up": 61656,
  "screwdriver": 62794,
  "folder-closed": 57733,
  "house-tsunami": 58645,
  "square-nfi": 58742,
  "arrow-up-from-ground-water": 58549,
  "martini-glass": 62843,
  "glass-martini-alt": 62843,
  "rotate-left": 62186,
  "rotate-back": 62186,
  "rotate-backward": 62186,
  "undo-alt": 62186,
  "table-columns": 61659,
  "columns": 61659,
  "lemon": 61588,
  "head-side-mask": 57443,
  "handshake": 62133,
  "gem": 62373,
  "dolly": 62578,
  "dolly-box": 62578,
  "smoking": 62605,
  "minimize": 63372,
  "compress-arrows-alt": 63372,
  "monument": 62886,
  "snowplow": 63442,
  "angles-right": 61697,
  "angle-double-right": 61697,
  "cannabis": 62815,
  "circle-play": 61764,
  "play-circle": 61764,
  "tablets": 62608,
  "ethernet": 63382,
  "euro-sign": 61779,
  "eur": 61779,
  "euro": 61779,
  "chair": 63168,
  "circle-check": 61528,
  "check-circle": 61528,
  "circle-stop": 62093,
  "stop-circle": 62093,
  "compass-drafting": 62824,
  "drafting-compass": 62824,
  "plate-wheat": 58714,
  "icicles": 63405,
  "person-shelter": 58703,
  "neuter": 61996,
  "id-badge": 62145,
  "marker": 62881,
  "face-laugh-beam": 62874,
  "laugh-beam": 62874,
  "helicopter-symbol": 58626,
  "universal-access": 62106,
  "circle-chevron-up": 61753,
  "chevron-circle-up": 61753,
  "lari-sign": 57800,
  "volcano": 63344,
  "person-walking-dashed-line-arrow-right": 58707,
  "sterling-sign": 61780,
  "gbp": 61780,
  "pound-sign": 61780,
  "viruses": 57462,
  "square-person-confined": 58743,
  "user-tie": 62728,
  "arrow-down-long": 61813,
  "long-arrow-down": 61813,
  "tent-arrow-down-to-line": 58750,
  "certificate": 61603,
  "reply-all": 61730,
  "mail-reply-all": 61730,
  "suitcase": 61682,
  "person-skating": 63429,
  "skating": 63429,
  "filter-circle-dollar": 63074,
  "funnel-dollar": 63074,
  "camera-retro": 61571,
  "circle-arrow-down": 61611,
  "arrow-circle-down": 61611,
  "file-import": 62831,
  "arrow-right-to-file": 62831,
  "square-arrow-up-right": 61772,
  "external-link-square": 61772,
  "box-open": 62622,
  "scroll": 63246,
  "spa": 62907,
  "location-pin-lock": 58655,
  "pause": 61516,
  "hill-avalanche": 58631,
  "temperature-empty": 62155,
  "temperature-0": 62155,
  "thermometer-0": 62155,
  "thermometer-empty": 62155,
  "bomb": 61922,
  "registered": 62045,
  "address-card": 62139,
  "contact-card": 62139,
  "vcard": 62139,
  "scale-unbalanced-flip": 62742,
  "balance-scale-right": 62742,
  "subscript": 61740,
  "diamond-turn-right": 62955,
  "directions": 62955,
  "burst": 58588,
  "house-laptop": 57446,
  "laptop-house": 57446,
  "face-tired": 62920,
  "tired": 62920,
  "money-bills": 57843,
  "smog": 63327,
  "crutch": 63479,
  "cloud-arrow-up": 61678,
  "cloud-upload": 61678,
  "cloud-upload-alt": 61678,
  "palette": 62783,
  "arrows-turn-right": 58560,
  "vest": 57477,
  "ferry": 58602,
  "arrows-down-to-people": 58553,
  "seedling": 62680,
  "sprout": 62680,
  "left-right": 62263,
  "arrows-alt-h": 62263,
  "boxes-packing": 58567,
  "circle-arrow-left": 61608,
  "arrow-circle-left": 61608,
  "group-arrows-rotate": 58614,
  "bowl-food": 58566,
  "candy-cane": 63366,
  "arrow-down-wide-short": 61792,
  "sort-amount-asc": 61792,
  "sort-amount-down": 61792,
  "cloud-bolt": 63340,
  "thunderstorm": 63340,
  "text-slash": 63613,
  "remove-format": 63613,
  "face-smile-wink": 62682,
  "smile-wink": 62682,
  "file-word": 61890,
  "file-powerpoint": 61892,
  "arrows-left-right": 61566,
  "arrows-h": 61566,
  "house-lock": 58640,
  "cloud-arrow-down": 61677,
  "cloud-download": 61677,
  "cloud-download-alt": 61677,
  "children": 58593,
  "chalkboard": 62747,
  "blackboard": 62747,
  "user-large-slash": 62714,
  "user-alt-slash": 62714,
  "envelope-open": 62134,
  "handshake-simple-slash": 57439,
  "handshake-alt-slash": 57439,
  "mattress-pillow": 58661,
  "guarani-sign": 57754,
  "arrows-rotate": 61473,
  "refresh": 61473,
  "sync": 61473,
  "fire-extinguisher": 61748,
  "cruzeiro-sign": 57682,
  "greater-than-equal": 62770,
  "shield-halved": 62445,
  "shield-alt": 62445,
  "book-atlas": 62808,
  "atlas": 62808,
  "virus": 57460,
  "envelope-circle-check": 58600,
  "layer-group": 62973,
  "arrows-to-dot": 58558,
  "archway": 62807,
  "heart-circle-check": 58621,
  "house-chimney-crack": 63217,
  "house-damage": 63217,
  "file-zipper": 61894,
  "file-archive": 61894,
  "square": 61640,
  "martini-glass-empty": 61440,
  "glass-martini": 61440,
  "couch": 62648,
  "cedi-sign": 57567,
  "italic": 61491,
  "table-cells-column-lock": 59000,
  "church": 62749,
  "comments-dollar": 63059,
  "democrat": 63303,
  "z": 90,
  "person-skiing": 63433,
  "skiing": 63433,
  "road-lock": 58727,
  "a": 65,
  "temperature-arrow-down": 57407,
  "temperature-down": 57407,
  "feather-pointed": 62827,
  "feather-alt": 62827,
  "p": 80,
  "snowflake": 62172,
  "newspaper": 61930,
  "rectangle-ad": 63041,
  "ad": 63041,
  "circle-arrow-right": 61609,
  "arrow-circle-right": 61609,
  "filter-circle-xmark": 57723,
  "locust": 58656,
  "sort": 61660,
  "unsorted": 61660,
  "list-ol": 61643,
  "list-1-2": 61643,
  "list-numeric": 61643,
  "person-dress-burst": 58692,
  "money-check-dollar": 62781,
  "money-check-alt": 62781,
  "vector-square": 62923,
  "bread-slice": 63468,
  "language": 61867,
  "face-kiss-wink-heart": 62872,
  "kiss-wink-heart": 62872,
  "filter": 61616,
  "question": 63,
  "file-signature": 62835,
  "up-down-left-right": 61618,
  "arrows-alt": 61618,
  "house-chimney-user": 57445,
  "hand-holding-heart": 62654,
  "puzzle-piece": 61742,
  "money-check": 62780,
  "star-half-stroke": 62912,
  "star-half-alt": 62912,
  "code": 61729,
  "whiskey-glass": 63392,
  "glass-whiskey": 63392,
  "building-circle-exclamation": 58579,
  "magnifying-glass-chart": 58658,
  "arrow-up-right-from-square": 61582,
  "external-link": 61582,
  "cubes-stacked": 58598,
  "won-sign": 61785,
  "krw": 61785,
  "won": 61785,
  "virus-covid": 58536,
  "austral-sign": 57513,
  "f": 70,
  "leaf": 61548,
  "road": 61464,
  "taxi": 61882,
  "cab": 61882,
  "person-circle-plus": 58689,
  "chart-pie": 61952,
  "pie-chart": 61952,
  "bolt-lightning": 57527,
  "sack-xmark": 58730,
  "file-excel": 61891,
  "file-contract": 62828,
  "fish-fins": 58610,
  "building-flag": 58581,
  "face-grin-beam": 62850,
  "grin-beam": 62850,
  "object-ungroup": 62024,
  "poop": 63001,
  "location-pin": 61505,
  "map-marker": 61505,
  "kaaba": 63083,
  "toilet-paper": 63262,
  "helmet-safety": 63495,
  "hard-hat": 63495,
  "hat-hard": 63495,
  "eject": 61522,
  "circle-right": 62298,
  "arrow-alt-circle-right": 62298,
  "plane-circle-check": 58709,
  "face-rolling-eyes": 62885,
  "meh-rolling-eyes": 62885,
  "object-group": 62023,
  "chart-line": 61953,
  "line-chart": 61953,
  "mask-ventilator": 58660,
  "arrow-right": 61537,
  "signs-post": 62071,
  "map-signs": 62071,
  "cash-register": 63368,
  "person-circle-question": 58690,
  "h": 72,
  "tarp": 58747,
  "screwdriver-wrench": 63449,
  "tools": 63449,
  "arrows-to-eye": 58559,
  "plug-circle-bolt": 58715,
  "heart": 61444,
  "mars-and-venus": 61988,
  "house-user": 57776,
  "home-user": 57776,
  "dumpster-fire": 63380,
  "house-crack": 58289,
  "martini-glass-citrus": 62817,
  "cocktail": 62817,
  "face-surprise": 62914,
  "surprise": 62914,
  "bottle-water": 58565,
  "circle-pause": 62091,
  "pause-circle": 62091,
  "toilet-paper-slash": 57458,
  "apple-whole": 62929,
  "apple-alt": 62929,
  "kitchen-set": 58650,
  "r": 82,
  "temperature-quarter": 62154,
  "temperature-1": 62154,
  "thermometer-1": 62154,
  "thermometer-quarter": 62154,
  "cube": 61874,
  "bitcoin-sign": 57524,
  "shield-dog": 58739,
  "solar-panel": 62906,
  "lock-open": 62401,
  "elevator": 57709,
  "money-bill-transfer": 58664,
  "money-bill-trend-up": 58665,
  "house-flood-water-circle-arrow-right": 58639,
  "square-poll-horizontal": 63106,
  "poll-h": 63106,
  "circle": 61713,
  "backward-fast": 61513,
  "fast-backward": 61513,
  "recycle": 61880,
  "user-astronaut": 62715,
  "plane-slash": 57449,
  "trademark": 62044,
  "basketball": 62516,
  "basketball-ball": 62516,
  "satellite-dish": 63424,
  "circle-up": 62299,
  "arrow-alt-circle-up": 62299,
  "mobile-screen-button": 62413,
  "mobile-alt": 62413,
  "volume-high": 61480,
  "volume-up": 61480,
  "users-rays": 58771,
  "wallet": 62805,
  "clipboard-check": 62572,
  "file-audio": 61895,
  "burger": 63493,
  "hamburger": 63493,
  "wrench": 61613,
  "bugs": 58576,
  "rupee-sign": 61782,
  "rupee": 61782,
  "file-image": 61893,
  "circle-question": 61529,
  "question-circle": 61529,
  "plane-departure": 62896,
  "handshake-slash": 57440,
  "book-bookmark": 57531,
  "code-branch": 61734,
  "hat-cowboy": 63680,
  "bridge": 58568,
  "phone-flip": 63609,
  "phone-alt": 63609,
  "truck-front": 58039,
  "cat": 63166,
  "anchor-circle-exclamation": 58539,
  "truck-field": 58765,
  "route": 62679,
  "clipboard-question": 58595,
  "panorama": 57865,
  "comment-medical": 63477,
  "teeth-open": 63023,
  "file-circle-minus": 58605,
  "tags": 61484,
  "wine-glass": 62691,
  "forward-fast": 61520,
  "fast-forward": 61520,
  "face-meh-blank": 62884,
  "meh-blank": 62884,
  "square-parking": 62784,
  "parking": 62784,
  "house-signal": 57362,
  "bars-progress": 63528,
  "tasks-alt": 63528,
  "faucet-drip": 57350,
  "cart-flatbed": 62580,
  "dolly-flatbed": 62580,
  "ban-smoking": 62797,
  "smoking-ban": 62797,
  "terminal": 61728,
  "mobile-button": 61707,
  "house-medical-flag": 58644,
  "basket-shopping": 62097,
  "shopping-basket": 62097,
  "tape": 62683,
  "bus-simple": 62814,
  "bus-alt": 62814,
  "eye": 61550,
  "face-sad-cry": 62899,
  "sad-cry": 62899,
  "audio-description": 62110,
  "person-military-to-person": 58700,
  "file-shield": 58608,
  "user-slash": 62726,
  "pen": 62212,
  "tower-observation": 58758,
  "file-code": 61897,
  "signal": 61458,
  "signal-5": 61458,
  "signal-perfect": 61458,
  "bus": 61959,
  "heart-circle-xmark": 58625,
  "house-chimney": 58287,
  "home-lg": 58287,
  "window-maximize": 62160,
  "face-frown": 61721,
  "frown": 61721,
  "prescription": 62897,
  "shop": 62799,
  "store-alt": 62799,
  "floppy-disk": 61639,
  "save": 61639,
  "vihara": 63143,
  "scale-unbalanced": 62741,
  "balance-scale-left": 62741,
  "sort-up": 61662,
  "sort-asc": 61662,
  "comment-dots": 62637,
  "commenting": 62637,
  "plant-wilt": 58794,
  "diamond": 61977,
  "face-grin-squint": 62853,
  "grin-squint": 62853,
  "hand-holding-dollar": 62656,
  "hand-holding-usd": 62656,
  "bacterium": 57434,
  "hand-pointer": 62042,
  "drum-steelpan": 62826,
  "hand-scissors": 62039,
  "hands-praying": 63108,
  "praying-hands": 63108,
  "arrow-rotate-right": 61470,
  "arrow-right-rotate": 61470,
  "arrow-rotate-forward": 61470,
  "redo": 61470,
  "biohazard": 63360,
  "location-crosshairs": 62977,
  "location": 62977,
  "mars-double": 61991,
  "child-dress": 58780,
  "users-between-lines": 58769,
  "lungs-virus": 57447,
  "face-grin-tears": 62856,
  "grin-tears": 62856,
  "phone": 61589,
  "calendar-xmark": 62067,
  "calendar-times": 62067,
  "child-reaching": 58781,
  "head-side-virus": 57444,
  "user-gear": 62718,
  "user-cog": 62718,
  "arrow-up-1-9": 61795,
  "sort-numeric-up": 61795,
  "door-closed": 62762,
  "shield-virus": 57452,
  "dice-six": 62758,
  "mosquito-net": 58668,
  "bridge-water": 58574,
  "person-booth": 63318,
  "text-width": 61493,
  "hat-wizard": 63208,
  "pen-fancy": 62892,
  "person-digging": 63582,
  "digging": 63582,
  "trash": 61944,
  "gauge-simple": 63017,
  "gauge-simple-med": 63017,
  "tachometer-average": 63017,
  "book-medical": 63462,
  "poo": 62206,
  "quote-right": 61710,
  "quote-right-alt": 61710,
  "shirt": 62803,
  "t-shirt": 62803,
  "tshirt": 62803,
  "cubes": 61875,
  "divide": 62761,
  "tenge-sign": 63447,
  "tenge": 63447,
  "headphones": 61477,
  "hands-holding": 62658,
  "hands-clapping": 57768,
  "republican": 63326,
  "arrow-left": 61536,
  "person-circle-xmark": 58691,
  "ruler": 62789,
  "align-left": 61494,
  "dice-d6": 63185,
  "restroom": 63421,
  "j": 74,
  "users-viewfinder": 58773,
  "file-video": 61896,
  "up-right-from-square": 62301,
  "external-link-alt": 62301,
  "table-cells": 61450,
  "th": 61450,
  "file-pdf": 61889,
  "book-bible": 63047,
  "bible": 63047,
  "o": 79,
  "suitcase-medical": 61690,
  "medkit": 61690,
  "user-secret": 61979,
  "otter": 63232,
  "person-dress": 61826,
  "female": 61826,
  "comment-dollar": 63057,
  "business-time": 63050,
  "briefcase-clock": 63050,
  "table-cells-large": 61449,
  "th-large": 61449,
  "book-tanakh": 63527,
  "tanakh": 63527,
  "phone-volume": 62112,
  "volume-control-phone": 62112,
  "hat-cowboy-side": 63681,
  "clipboard-user": 63475,
  "child": 61870,
  "lira-sign": 61845,
  "satellite": 63423,
  "plane-lock": 58712,
  "tag": 61483,
  "comment": 61557,
  "cake-candles": 61949,
  "birthday-cake": 61949,
  "cake": 61949,
  "envelope": 61664,
  "angles-up": 61698,
  "angle-double-up": 61698,
  "paperclip": 61638,
  "arrow-right-to-city": 58547,
  "ribbon": 62678,
  "lungs": 62980,
  "arrow-up-9-1": 63623,
  "sort-numeric-up-alt": 63623,
  "litecoin-sign": 57811,
  "border-none": 63568,
  "circle-nodes": 58594,
  "parachute-box": 62669,
  "indent": 61500,
  "truck-field-un": 58766,
  "hourglass": 62036,
  "hourglass-empty": 62036,
  "mountain": 63228,
  "user-doctor": 61680,
  "user-md": 61680,
  "circle-info": 61530,
  "info-circle": 61530,
  "cloud-meatball": 63291,
  "camera": 61488,
  "camera-alt": 61488,
  "square-virus": 58744,
  "meteor": 63315,
  "car-on": 58589,
  "sleigh": 63436,
  "arrow-down-1-9": 61794,
  "sort-numeric-asc": 61794,
  "sort-numeric-down": 61794,
  "hand-holding-droplet": 62657,
  "hand-holding-water": 62657,
  "water": 63347,
  "calendar-check": 62068,
  "braille": 62113,
  "prescription-bottle-medical": 62598,
  "prescription-bottle-alt": 62598,
  "landmark": 63087,
  "truck": 61649,
  "crosshairs": 61531,
  "person-cane": 58684,
  "tent": 58749,
  "vest-patches": 57478,
  "check-double": 62816,
  "arrow-down-a-z": 61789,
  "sort-alpha-asc": 61789,
  "sort-alpha-down": 61789,
  "money-bill-wheat": 58666,
  "cookie": 62819,
  "arrow-rotate-left": 61666,
  "arrow-left-rotate": 61666,
  "arrow-rotate-back": 61666,
  "arrow-rotate-backward": 61666,
  "undo": 61666,
  "hard-drive": 61600,
  "hdd": 61600,
  "face-grin-squint-tears": 62854,
  "grin-squint-tears": 62854,
  "dumbbell": 62539,
  "rectangle-list": 61474,
  "list-alt": 61474,
  "tarp-droplet": 58748,
  "house-medical-circle-check": 58641,
  "person-skiing-nordic": 63434,
  "skiing-nordic": 63434,
  "calendar-plus": 62065,
  "plane-arrival": 62895,
  "circle-left": 62297,
  "arrow-alt-circle-left": 62297,
  "train-subway": 62009,
  "subway": 62009,
  "chart-gantt": 57572,
  "indian-rupee-sign": 57788,
  "indian-rupee": 57788,
  "inr": 57788,
  "crop-simple": 62821,
  "crop-alt": 62821,
  "money-bill-1": 62417,
  "money-bill-alt": 62417,
  "left-long": 62218,
  "long-arrow-alt-left": 62218,
  "dna": 62577,
  "virus-slash": 57461,
  "minus": 61544,
  "subtract": 61544,
  "chess": 62521,
  "arrow-left-long": 61815,
  "long-arrow-left": 61815,
  "plug-circle-check": 58716,
  "street-view": 61981,
  "franc-sign": 57743,
  "volume-off": 61478,
  "hands-asl-interpreting": 62115,
  "american-sign-language-interpreting": 62115,
  "asl-interpreting": 62115,
  "hands-american-sign-language-interpreting": 62115,
  "gear": 61459,
  "cog": 61459,
  "droplet-slash": 62919,
  "tint-slash": 62919,
  "mosque": 63096,
  "mosquito": 58667,
  "star-of-david": 63130,
  "person-military-rifle": 58699,
  "cart-shopping": 61562,
  "shopping-cart": 61562,
  "vials": 62611,
  "plug-circle-plus": 58719,
  "place-of-worship": 63103,
  "grip-vertical": 62862,
  "arrow-turn-up": 61768,
  "level-up": 61768,
  "u": 85,
  "square-root-variable": 63128,
  "square-root-alt": 63128,
  "clock": 61463,
  "clock-four": 61463,
  "backward-step": 61512,
  "step-backward": 61512,
  "pallet": 62594,
  "faucet": 57349,
  "baseball-bat-ball": 62514,
  "s": 83,
  "timeline": 58012,
  "keyboard": 61724,
  "caret-down": 61655,
  "house-chimney-medical": 63474,
  "clinic-medical": 63474,
  "temperature-three-quarters": 62152,
  "temperature-3": 62152,
  "thermometer-3": 62152,
  "thermometer-three-quarters": 62152,
  "mobile-screen": 62415,
  "mobile-android-alt": 62415,
  "plane-up": 57901,
  "piggy-bank": 62675,
  "battery-half": 62018,
  "battery-3": 62018,
  "mountain-city": 58670,
  "coins": 62750,
  "khanda": 63085,
  "sliders": 61918,
  "sliders-h": 61918,
  "folder-tree": 63490,
  "network-wired": 63231,
  "map-pin": 62070,
  "hamsa": 63077,
  "cent-sign": 58357,
  "flask": 61635,
  "person-pregnant": 58142,
  "wand-sparkles": 63275,
  "ellipsis-vertical": 61762,
  "ellipsis-v": 61762,
  "ticket": 61765,
  "power-off": 61457,
  "right-long": 62219,
  "long-arrow-alt-right": 62219,
  "flag-usa": 63309,
  "laptop-file": 58653,
  "tty": 61924,
  "teletype": 61924,
  "diagram-next": 58486,
  "person-rifle": 58702,
  "house-medical-circle-exclamation": 58642,
  "closed-captioning": 61962,
  "person-hiking": 63212,
  "hiking": 63212,
  "venus-double": 61990,
  "images": 62210,
  "calculator": 61932,
  "people-pulling": 58677,
  "n": 78,
  "cable-car": 63450,
  "tram": 63450,
  "cloud-rain": 63293,
  "building-circle-xmark": 58580,
  "ship": 61978,
  "arrows-down-to-line": 58552,
  "download": 61465,
  "face-grin": 62848,
  "grin": 62848,
  "delete-left": 62810,
  "backspace": 62810,
  "eye-dropper": 61947,
  "eye-dropper-empty": 61947,
  "eyedropper": 61947,
  "file-circle-check": 58784,
  "forward": 61518,
  "mobile": 62414,
  "mobile-android": 62414,
  "mobile-phone": 62414,
  "face-meh": 61722,
  "meh": 61722,
  "align-center": 61495,
  "book-skull": 63159,
  "book-dead": 63159,
  "id-card": 62146,
  "drivers-license": 62146,
  "outdent": 61499,
  "dedent": 61499,
  "heart-circle-exclamation": 58622,
  "house": 61461,
  "home": 61461,
  "home-alt": 61461,
  "home-lg-alt": 61461,
  "calendar-week": 63364,
  "laptop-medical": 63506,
  "b": 66,
  "file-medical": 62583,
  "dice-one": 62757,
  "kiwi-bird": 62773,
  "arrow-right-arrow-left": 61676,
  "exchange": 61676,
  "rotate-right": 62201,
  "redo-alt": 62201,
  "rotate-forward": 62201,
  "utensils": 62183,
  "cutlery": 62183,
  "arrow-up-wide-short": 61793,
  "sort-amount-up": 61793,
  "mill-sign": 57837,
  "bowl-rice": 58091,
  "skull": 62796,
  "tower-broadcast": 62745,
  "broadcast-tower": 62745,
  "truck-pickup": 63036,
  "up-long": 62220,
  "long-arrow-alt-up": 62220,
  "stop": 61517,
  "code-merge": 62343,
  "upload": 61587,
  "hurricane": 63313,
  "mound": 58669,
  "toilet-portable": 58755,
  "compact-disc": 62751,
  "file-arrow-down": 62829,
  "file-download": 62829,
  "caravan": 63743,
  "shield-cat": 58738,
  "bolt": 61671,
  "zap": 61671,
  "glass-water": 58612,
  "oil-well": 58674,
  "vault": 58053,
  "mars": 61986,
  "toilet": 63448,
  "plane-circle-xmark": 58711,
  "yen-sign": 61783,
  "cny": 61783,
  "jpy": 61783,
  "rmb": 61783,
  "yen": 61783,
  "ruble-sign": 61784,
  "rouble": 61784,
  "rub": 61784,
  "ruble": 61784,
  "sun": 61829,
  "guitar": 63398,
  "face-laugh-wink": 62876,
  "laugh-wink": 62876,
  "horse-head": 63403,
  "bore-hole": 58563,
  "industry": 62069,
  "circle-down": 62296,
  "arrow-alt-circle-down": 62296,
  "arrows-turn-to-dots": 58561,
  "florin-sign": 57732,
  "arrow-down-short-wide": 63620,
  "sort-amount-desc": 63620,
  "sort-amount-down-alt": 63620,
  "less-than": 60,
  "angle-down": 61703,
  "car-tunnel": 58590,
  "head-side-cough": 57441,
  "grip-lines": 63396,
  "thumbs-down": 61797,
  "user-lock": 62722,
  "arrow-right-long": 61816,
  "long-arrow-right": 61816,
  "anchor-circle-xmark": 58540,
  "ellipsis": 61761,
  "ellipsis-h": 61761,
  "chess-pawn": 62531,
  "kit-medical": 62585,
  "first-aid": 62585,
  "person-through-window": 58793,
  "toolbox": 62802,
  "hands-holding-circle": 58619,
  "bug": 61832,
  "credit-card": 61597,
  "credit-card-alt": 61597,
  "car": 61881,
  "automobile": 61881,
  "hand-holding-hand": 58615,
  "book-open-reader": 62938,
  "book-reader": 62938,
  "mountain-sun": 58671,
  "arrows-left-right-to-line": 58554,
  "dice-d20": 63183,
  "truck-droplet": 58764,
  "file-circle-xmark": 58785,
  "temperature-arrow-up": 57408,
  "temperature-up": 57408,
  "medal": 62882,
  "bed": 62006,
  "square-h": 61693,
  "h-square": 61693,
  "podcast": 62158,
  "temperature-full": 62151,
  "temperature-4": 62151,
  "thermometer-4": 62151,
  "thermometer-full": 62151,
  "bell": 61683,
  "superscript": 61739,
  "plug-circle-xmark": 58720,
  "star-of-life": 63009,
  "phone-slash": 62429,
  "paint-roller": 62890,
  "handshake-angle": 62660,
  "hands-helping": 62660,
  "location-dot": 62405,
  "map-marker-alt": 62405,
  "file": 61787,
  "greater-than": 62,
  "person-swimming": 62916,
  "swimmer": 62916,
  "arrow-down": 61539,
  "droplet": 61507,
  "tint": 61507,
  "eraser": 61741,
  "earth-americas": 62845,
  "earth": 62845,
  "earth-america": 62845,
  "globe-americas": 62845,
  "person-burst": 58683,
  "dove": 62650,
  "battery-empty": 62020,
  "battery-0": 62020,
  "socks": 63126,
  "inbox": 61468,
  "section": 58439,
  "gauge-high": 63013,
  "tachometer-alt": 63013,
  "tachometer-alt-fast": 63013,
  "envelope-open-text": 63064,
  "hospital": 61688,
  "hospital-alt": 61688,
  "hospital-wide": 61688,
  "wine-bottle": 63279,
  "chess-rook": 62535,
  "bars-staggered": 62800,
  "reorder": 62800,
  "stream": 62800,
  "dharmachakra": 63061,
  "hotdog": 63503,
  "person-walking-with-cane": 62109,
  "blind": 62109,
  "drum": 62825,
  "ice-cream": 63504,
  "heart-circle-bolt": 58620,
  "fax": 61868,
  "paragraph": 61917,
  "check-to-slot": 63346,
  "vote-yea": 63346,
  "star-half": 61577,
  "boxes-stacked": 62568,
  "boxes": 62568,
  "boxes-alt": 62568,
  "link": 61633,
  "chain": 61633,
  "ear-listen": 62114,
  "assistive-listening-systems": 62114,
  "tree-city": 58759,
  "play": 61515,
  "font": 61489,
  "table-cells-row-lock": 59002,
  "rupiah-sign": 57917,
  "magnifying-glass": 61442,
  "search": 61442,
  "table-tennis-paddle-ball": 62557,
  "ping-pong-paddle-ball": 62557,
  "table-tennis": 62557,
  "person-dots-from-line": 62576,
  "diagnoses": 62576,
  "trash-can-arrow-up": 63530,
  "trash-restore-alt": 63530,
  "naira-sign": 57846,
  "cart-arrow-down": 61976,
  "walkie-talkie": 63727,
  "file-pen": 62236,
  "file-edit": 62236,
  "receipt": 62787,
  "square-pen": 61771,
  "pen-square": 61771,
  "pencil-square": 61771,
  "suitcase-rolling": 62913,
  "person-circle-exclamation": 58687,
  "chevron-down": 61560,
  "battery-full": 62016,
  "battery": 62016,
  "battery-5": 62016,
  "skull-crossbones": 63252,
  "code-compare": 57658,
  "list-ul": 61642,
  "list-dots": 61642,
  "school-lock": 58735,
  "tower-cell": 58757,
  "down-long": 62217,
  "long-arrow-alt-down": 62217,
  "ranking-star": 58721,
  "chess-king": 62527,
  "person-harassing": 58697,
  "brazilian-real-sign": 58476,
  "landmark-dome": 63314,
  "landmark-alt": 63314,
  "arrow-up": 61538,
  "tv": 62060,
  "television": 62060,
  "tv-alt": 62060,
  "shrimp": 58440,
  "list-check": 61614,
  "tasks": 61614,
  "jug-detergent": 58649,
  "circle-user": 62141,
  "user-circle": 62141,
  "user-shield": 62725,
  "wind": 63278,
  "car-burst": 62945,
  "car-crash": 62945,
  "y": 89,
  "person-snowboarding": 63438,
  "snowboarding": 63438,
  "truck-fast": 62603,
  "shipping-fast": 62603,
  "fish": 62840,
  "user-graduate": 62721,
  "circle-half-stroke": 61506,
  "adjust": 61506,
  "clapperboard": 57649,
  "circle-radiation": 63418,
  "radiation-alt": 63418,
  "baseball": 62515,
  "baseball-ball": 62515,
  "jet-fighter-up": 58648,
  "diagram-project": 62786,
  "project-diagram": 62786,
  "copy": 61637,
  "volume-xmark": 63145,
  "volume-mute": 63145,
  "volume-times": 63145,
  "hand-sparkles": 57437,
  "grip": 62861,
  "grip-horizontal": 62861,
  "share-from-square": 61773,
  "share-square": 61773,
  "child-combatant": 58592,
  "child-rifle": 58592,
  "gun": 57755,
  "square-phone": 61592,
  "phone-square": 61592,
  "plus": 43,
  "add": 43,
  "expand": 61541,
  "computer": 58597,
  "xmark": 61453,
  "close": 61453,
  "multiply": 61453,
  "remove": 61453,
  "times": 61453,
  "arrows-up-down-left-right": 61511,
  "arrows": 61511,
  "chalkboard-user": 62748,
  "chalkboard-teacher": 62748,
  "peso-sign": 57890,
  "building-shield": 58584,
  "baby": 63356,
  "users-line": 58770,
  "quote-left": 61709,
  "quote-left-alt": 61709,
  "tractor": 63266,
  "trash-arrow-up": 63529,
  "trash-restore": 63529,
  "arrow-down-up-lock": 58544,
  "lines-leaning": 58654,
  "ruler-combined": 62790,
  "copyright": 61945,
  "equals": 61,
  "blender": 62743,
  "teeth": 63022,
  "shekel-sign": 61963,
  "ils": 61963,
  "shekel": 61963,
  "sheqel": 61963,
  "sheqel-sign": 61963,
  "map": 62073,
  "rocket": 61749,
  "photo-film": 63612,
  "photo-video": 63612,
  "folder-minus": 63069,
  "store": 62798,
  "arrow-trend-up": 57496,
  "plug-circle-minus": 58718,
  "sign-hanging": 62681,
  "sign": 62681,
  "bezier-curve": 62811,
  "bell-slash": 61942,
  "tablet": 62459,
  "tablet-android": 62459,
  "school-flag": 58734,
  "fill": 62837,
  "angle-up": 61702,
  "drumstick-bite": 63191,
  "holly-berry": 63402,
  "chevron-left": 61523,
  "bacteria": 57433,
  "hand-lizard": 62040,
  "notdef": 57854,
  "disease": 63482,
  "briefcase-medical": 62569,
  "genderless": 61997,
  "chevron-right": 61524,
  "retweet": 61561,
  "car-rear": 62942,
  "car-alt": 62942,
  "pump-soap": 57451,
  "video-slash": 62690,
  "battery-quarter": 62019,
  "battery-2": 62019,
  "radio": 63703,
  "baby-carriage": 63357,
  "carriage-baby": 63357,
  "traffic-light": 63031,
  "thermometer": 62609,
  "vr-cardboard": 63273,
  "hand-middle-finger": 63494,
  "percent": 37,
  "percentage": 37,
  "truck-moving": 62687,
  "glass-water-droplet": 58613,
  "display": 57699,
  "face-smile": 61720,
  "smile": 61720,
  "thumbtack": 61581,
  "thumb-tack": 61581,
  "trophy": 61585,
  "person-praying": 63107,
  "pray": 63107,
  "hammer": 63203,
  "hand-peace": 62043,
  "rotate": 62193,
  "sync-alt": 62193,
  "spinner": 61712,
  "robot": 62788,
  "peace": 63100,
  "gears": 61573,
  "cogs": 61573,
  "warehouse": 62612,
  "arrow-up-right-dots": 58551,
  "splotch": 62908,
  "face-grin-hearts": 62852,
  "grin-hearts": 62852,
  "dice-four": 62756,
  "sim-card": 63428,
  "transgender": 61989,
  "transgender-alt": 61989,
  "mercury": 61987,
  "arrow-turn-down": 61769,
  "level-down": 61769,
  "person-falling-burst": 58695,
  "award": 62809,
  "ticket-simple": 62463,
  "ticket-alt": 62463,
  "building": 61869,
  "angles-left": 61696,
  "angle-double-left": 61696,
  "qrcode": 61481,
  "clock-rotate-left": 61914,
  "history": 61914,
  "face-grin-beam-sweat": 62851,
  "grin-beam-sweat": 62851,
  "file-export": 62830,
  "arrow-right-from-file": 62830,
  "shield": 61746,
  "shield-blank": 61746,
  "arrow-up-short-wide": 63621,
  "sort-amount-up-alt": 63621,
  "house-medical": 58290,
  "golf-ball-tee": 62544,
  "golf-ball": 62544,
  "circle-chevron-left": 61751,
  "chevron-circle-left": 61751,
  "house-chimney-window": 57357,
  "pen-nib": 62893,
  "tent-arrow-turn-left": 58752,
  "tents": 58754,
  "wand-magic": 61648,
  "magic": 61648,
  "dog": 63187,
  "carrot": 63367,
  "moon": 61830,
  "wine-glass-empty": 62926,
  "wine-glass-alt": 62926,
  "cheese": 63471,
  "yin-yang": 63149,
  "music": 61441,
  "code-commit": 62342,
  "temperature-low": 63339,
  "person-biking": 63562,
  "biking": 63562,
  "broom": 62746,
  "shield-heart": 58740,
  "gopuram": 63076,
  "earth-oceania": 58491,
  "globe-oceania": 58491,
  "square-xmark": 62163,
  "times-square": 62163,
  "xmark-square": 62163,
  "hashtag": 35,
  "up-right-and-down-left-from-center": 62500,
  "expand-alt": 62500,
  "oil-can": 62995,
  "t": 84,
  "hippo": 63213,
  "chart-column": 57571,
  "infinity": 62772,
  "vial-circle-check": 58774,
  "person-arrow-down-to-line": 58680,
  "voicemail": 63639,
  "fan": 63587,
  "person-walking-luggage": 58708,
  "up-down": 62264,
  "arrows-alt-v": 62264,
  "cloud-moon-rain": 63292,
  "calendar": 61747,
  "trailer": 57409,
  "bahai": 63078,
  "haykal": 63078,
  "sd-card": 63426,
  "dragon": 63189,
  "shoe-prints": 62795,
  "circle-plus": 61525,
  "plus-circle": 61525,
  "face-grin-tongue-wink": 62859,
  "grin-tongue-wink": 62859,
  "hand-holding": 62653,
  "plug-circle-exclamation": 58717,
  "link-slash": 61735,
  "chain-broken": 61735,
  "chain-slash": 61735,
  "unlink": 61735,
  "clone": 62029,
  "person-walking-arrow-loop-left": 58705,
  "arrow-up-z-a": 63618,
  "sort-alpha-up-alt": 63618,
  "fire-flame-curved": 63460,
  "fire-alt": 63460,
  "tornado": 63343,
  "file-circle-plus": 58516,
  "book-quran": 63111,
  "quran": 63111,
  "anchor": 61757,
  "border-all": 63564,
  "face-angry": 62806,
  "angry": 62806,
  "cookie-bite": 62820,
  "arrow-trend-down": 57495,
  "rss": 61598,
  "feed": 61598,
  "draw-polygon": 62958,
  "scale-balanced": 62030,
  "balance-scale": 62030,
  "gauge-simple-high": 63018,
  "tachometer": 63018,
  "tachometer-fast": 63018,
  "shower": 62156,
  "desktop": 62352,
  "desktop-alt": 62352,
  "m": 77,
  "table-list": 61451,
  "th-list": 61451,
  "comment-sms": 63437,
  "sms": 63437,
  "book": 61485,
  "user-plus": 62004,
  "check": 61452,
  "battery-three-quarters": 62017,
  "battery-4": 62017,
  "house-circle-check": 58633,
  "angle-left": 61700,
  "diagram-successor": 58490,
  "truck-arrow-right": 58763,
  "arrows-split-up-and-left": 58556,
  "hand-fist": 63198,
  "fist-raised": 63198,
  "cloud-moon": 63171,
  "briefcase": 61617,
  "person-falling": 58694,
  "image-portrait": 62432,
  "portrait": 62432,
  "user-tag": 62727,
  "rug": 58729,
  "earth-europe": 63394,
  "globe-europe": 63394,
  "cart-flatbed-suitcase": 62877,
  "luggage-cart": 62877,
  "rectangle-xmark": 62480,
  "rectangle-times": 62480,
  "times-rectangle": 62480,
  "window-close": 62480,
  "baht-sign": 57516,
  "book-open": 62744,
  "book-journal-whills": 63082,
  "journal-whills": 63082,
  "handcuffs": 58616,
  "triangle-exclamation": 61553,
  "exclamation-triangle": 61553,
  "warning": 61553,
  "database": 61888,
  "share": 61540,
  "mail-forward": 61540,
  "bottle-droplet": 58564,
  "mask-face": 57815,
  "hill-rockslide": 58632,
  "right-left": 62306,
  "exchange-alt": 62306,
  "paper-plane": 61912,
  "road-circle-exclamation": 58725,
  "dungeon": 63193,
  "align-right": 61496,
  "money-bill-1-wave": 62779,
  "money-bill-wave-alt": 62779,
  "life-ring": 61901,
  "hands": 62119,
  "sign-language": 62119,
  "signing": 62119,
  "calendar-day": 63363,
  "water-ladder": 62917,
  "ladder-water": 62917,
  "swimming-pool": 62917,
  "arrows-up-down": 61565,
  "arrows-v": 61565,
  "face-grimace": 62847,
  "grimace": 62847,
  "wheelchair-move": 58062,
  "wheelchair-alt": 58062,
  "turn-down": 62398,
  "level-down-alt": 62398,
  "person-walking-arrow-right": 58706,
  "square-envelope": 61849,
  "envelope-square": 61849,
  "dice": 62754,
  "bowling-ball": 62518,
  "brain": 62940,
  "bandage": 62562,
  "band-aid": 62562,
  "calendar-minus": 62066,
  "circle-xmark": 61527,
  "times-circle": 61527,
  "xmark-circle": 61527,
  "gifts": 63388,
  "hotel": 62868,
  "earth-asia": 62846,
  "globe-asia": 62846,
  "id-card-clip": 62591,
  "id-card-alt": 62591,
  "magnifying-glass-plus": 61454,
  "search-plus": 61454,
  "thumbs-up": 61796,
  "user-clock": 62717,
  "hand-dots": 62561,
  "allergies": 62561,
  "file-invoice": 62832,
  "window-minimize": 62161,
  "mug-saucer": 61684,
  "coffee": 61684,
  "brush": 62813,
  "mask": 63226,
  "magnifying-glass-minus": 61456,
  "search-minus": 61456,
  "ruler-vertical": 62792,
  "user-large": 62470,
  "user-alt": 62470,
  "train-tram": 58804,
  "user-nurse": 63535,
  "syringe": 62606,
  "cloud-sun": 63172,
  "stopwatch-20": 57455,
  "square-full": 62556,
  "magnet": 61558,
  "jar": 58646,
  "note-sticky": 62025,
  "sticky-note": 62025,
  "bug-slash": 58512,
  "arrow-up-from-water-pump": 58550,
  "bone": 62935,
  "table-cells-row-unlock": 59025,
  "user-injured": 63272,
  "face-sad-tear": 62900,
  "sad-tear": 62900,
  "plane": 61554,
  "tent-arrows-down": 58753,
  "exclamation": 33,
  "arrows-spin": 58555,
  "print": 61487,
  "turkish-lira-sign": 58043,
  "try": 58043,
  "turkish-lira": 58043,
  "dollar-sign": 36,
  "dollar": 36,
  "usd": 36,
  "x": 88,
  "magnifying-glass-dollar": 63112,
  "search-dollar": 63112,
  "users-gear": 62729,
  "users-cog": 62729,
  "person-military-pointing": 58698,
  "building-columns": 61852,
  "bank": 61852,
  "institution": 61852,
  "museum": 61852,
  "university": 61852,
  "umbrella": 61673,
  "trowel": 58761,
  "d": 68,
  "stapler": 58799,
  "masks-theater": 63024,
  "theater-masks": 63024,
  "kip-sign": 57796,
  "hand-point-left": 61605,
  "handshake-simple": 62662,
  "handshake-alt": 62662,
  "jet-fighter": 61691,
  "fighter-jet": 61691,
  "square-share-nodes": 61921,
  "share-alt-square": 61921,
  "barcode": 61482,
  "plus-minus": 58428,
  "video": 61501,
  "video-camera": 61501,
  "graduation-cap": 61853,
  "mortar-board": 61853,
  "hand-holding-medical": 57436,
  "person-circle-check": 58686,
  "turn-up": 62399,
  "level-up-alt": 62399,
  "monero": 62416,
  "hooli": 62503,
  "yelp": 61929,
  "cc-visa": 61936,
  "lastfm": 61954,
  "shopware": 62901,
  "creative-commons-nc": 62696,
  "aws": 62325,
  "redhat": 63420,
  "yoast": 62129,
  "cloudflare": 57469,
  "ups": 63456,
  "pixiv": 58944,
  "wpexplorer": 62174,
  "dyalog": 62361,
  "bity": 62330,
  "stackpath": 63554,
  "buysellads": 61965,
  "first-order": 62128,
  "modx": 62085,
  "guilded": 57470,
  "vnv": 62475,
  "square-js": 62393,
  "js-square": 62393,
  "microsoft": 62410,
  "qq": 61910,
  "orcid": 63698,
  "java": 62692,
  "invision": 63408,
  "creative-commons-pd-alt": 62701,
  "centercode": 62336,
  "glide-g": 62118,
  "drupal": 61865,
  "jxl": 59003,
  "dart-lang": 59027,
  "hire-a-helper": 62384,
  "creative-commons-by": 62695,
  "unity": 57417,
  "whmcs": 62477,
  "rocketchat": 62440,
  "vk": 61833,
  "untappd": 62469,
  "mailchimp": 62878,
  "css3-alt": 62347,
  "square-reddit": 61858,
  "reddit-square": 61858,
  "vimeo-v": 62077,
  "contao": 62061,
  "square-font-awesome": 58797,
  "deskpro": 62351,
  "brave": 58940,
  "sistrix": 62446,
  "square-instagram": 57429,
  "instagram-square": 57429,
  "battle-net": 63541,
  "the-red-yeti": 63133,
  "square-hacker-news": 62383,
  "hacker-news-square": 62383,
  "edge": 62082,
  "threads": 58904,
  "napster": 62418,
  "square-snapchat": 62125,
  "snapchat-square": 62125,
  "google-plus-g": 61653,
  "artstation": 63354,
  "markdown": 62991,
  "sourcetree": 63443,
  "google-plus": 62131,
  "diaspora": 63377,
  "foursquare": 61824,
  "stack-overflow": 61804,
  "github-alt": 61715,
  "phoenix-squadron": 62737,
  "pagelines": 61836,
  "algolia": 62316,
  "red-river": 62435,
  "creative-commons-sa": 62703,
  "safari": 62055,
  "google": 61856,
  "square-font-awesome-stroke": 62300,
  "font-awesome-alt": 62300,
  "atlassian": 63355,
  "linkedin-in": 61665,
  "digital-ocean": 62353,
  "nimblr": 62888,
  "chromecast": 63544,
  "evernote": 63545,
  "hacker-news": 61908,
  "creative-commons-sampling": 62704,
  "adversal": 62314,
  "creative-commons": 62046,
  "watchman-monitoring": 57479,
  "fonticons": 62080,
  "weixin": 61911,
  "shirtsinbulk": 61972,
  "codepen": 61899,
  "git-alt": 63553,
  "lyft": 62403,
  "rev": 62898,
  "windows": 61818,
  "wizards-of-the-coast": 63280,
  "square-viadeo": 62122,
  "viadeo-square": 62122,
  "meetup": 62176,
  "centos": 63369,
  "adn": 61808,
  "cloudsmith": 62340,
  "opensuse": 58923,
  "pied-piper-alt": 61864,
  "square-dribbble": 62359,
  "dribbble-square": 62359,
  "codiepie": 62084,
  "node": 62489,
  "mix": 62411,
  "steam": 61878,
  "cc-apple-pay": 62486,
  "scribd": 62090,
  "debian": 58891,
  "openid": 61851,
  "instalod": 57473,
  "expeditedssl": 62014,
  "sellcast": 62170,
  "square-twitter": 61569,
  "twitter-square": 61569,
  "r-project": 62711,
  "delicious": 61861,
  "freebsd": 62372,
  "vuejs": 62495,
  "accusoft": 62313,
  "ioxhost": 61960,
  "fonticons-fi": 62370,
  "app-store": 62319,
  "cc-mastercard": 61937,
  "itunes-note": 62389,
  "golang": 58383,
  "kickstarter": 62395,
  "square-kickstarter": 62395,
  "grav": 62166,
  "weibo": 61834,
  "uncharted": 57476,
  "firstdraft": 62369,
  "square-youtube": 62513,
  "youtube-square": 62513,
  "wikipedia-w": 62054,
  "wpressr": 62436,
  "rendact": 62436,
  "angellist": 61961,
  "galactic-republic": 62732,
  "nfc-directional": 58672,
  "skype": 61822,
  "joget": 62391,
  "fedora": 63384,
  "stripe-s": 62506,
  "meta": 58523,
  "laravel": 62397,
  "hotjar": 62385,
  "bluetooth-b": 62100,
  "square-letterboxd": 58926,
  "sticker-mule": 62455,
  "creative-commons-zero": 62707,
  "hips": 62546,
  "behance": 61876,
  "reddit": 61857,
  "discord": 62354,
  "chrome": 62056,
  "app-store-ios": 62320,
  "cc-discover": 61938,
  "wpbeginner": 62103,
  "confluence": 63373,
  "shoelace": 58892,
  "mdb": 63690,
  "dochub": 62356,
  "accessible-icon": 62312,
  "ebay": 62708,
  "amazon": 62064,
  "unsplash": 57468,
  "yarn": 63459,
  "square-steam": 61879,
  "steam-square": 61879,
  "500px": 62062,
  "square-vimeo": 61844,
  "vimeo-square": 61844,
  "asymmetrik": 62322,
  "font-awesome": 62132,
  "font-awesome-flag": 62132,
  "font-awesome-logo-full": 62132,
  "gratipay": 61828,
  "apple": 61817,
  "hive": 57471,
  "gitkraken": 62374,
  "keybase": 62709,
  "apple-pay": 62485,
  "padlet": 58528,
  "amazon-pay": 62508,
  "square-github": 61586,
  "github-square": 61586,
  "stumbleupon": 61860,
  "fedex": 63383,
  "phoenix-framework": 62428,
  "shopify": 57431,
  "neos": 62994,
  "square-threads": 58905,
  "hackerrank": 62967,
  "researchgate": 62712,
  "swift": 63713,
  "angular": 62496,
  "speakap": 62451,
  "angrycreative": 62318,
  "y-combinator": 62011,
  "empire": 61905,
  "envira": 62105,
  "google-scholar": 58939,
  "square-gitlab": 58798,
  "gitlab-square": 58798,
  "studiovinari": 62456,
  "pied-piper": 62126,
  "wordpress": 61850,
  "product-hunt": 62088,
  "firefox": 62057,
  "linode": 62136,
  "goodreads": 62376,
  "square-odnoklassniki": 62052,
  "odnoklassniki-square": 62052,
  "jsfiddle": 61900,
  "sith": 62738,
  "themeisle": 62130,
  "page4": 62423,
  "hashnode": 58521,
  "react": 62491,
  "cc-paypal": 61940,
  "squarespace": 62910,
  "cc-stripe": 61941,
  "creative-commons-share": 62706,
  "bitcoin": 62329,
  "keycdn": 62394,
  "opera": 62058,
  "itch-io": 63546,
  "umbraco": 63720,
  "galactic-senate": 62733,
  "ubuntu": 63455,
  "draft2digital": 62358,
  "stripe": 62505,
  "houzz": 62076,
  "gg": 62048,
  "dhl": 63376,
  "square-pinterest": 61651,
  "pinterest-square": 61651,
  "xing": 61800,
  "blackberry": 62331,
  "creative-commons-pd": 62700,
  "playstation": 62431,
  "quinscape": 62553,
  "less": 62493,
  "blogger-b": 62333,
  "opencart": 62013,
  "vine": 61898,
  "signal-messenger": 58979,
  "paypal": 61933,
  "gitlab": 62102,
  "typo3": 62507,
  "reddit-alien": 62081,
  "yahoo": 61854,
  "dailymotion": 57426,
  "affiliatetheme": 62315,
  "pied-piper-pp": 61863,
  "bootstrap": 63542,
  "odnoklassniki": 62051,
  "nfc-symbol": 58673,
  "mintbit": 58927,
  "ethereum": 62510,
  "speaker-deck": 63548,
  "creative-commons-nc-eu": 62697,
  "patreon": 62425,
  "avianex": 62324,
  "ello": 62961,
  "gofore": 62375,
  "bimobject": 62328,
  "brave-reverse": 58941,
  "facebook-f": 62366,
  "square-google-plus": 61652,
  "google-plus-square": 61652,
  "web-awesome": 59010,
  "mandalorian": 62735,
  "first-order-alt": 62730,
  "osi": 62490,
  "google-wallet": 61934,
  "d-and-d-beyond": 63178,
  "periscope": 62426,
  "fulcrum": 62731,
  "cloudscale": 62339,
  "forumbee": 61969,
  "mizuni": 62412,
  "schlix": 62442,
  "square-xing": 61801,
  "xing-square": 61801,
  "bandcamp": 62165,
  "wpforms": 62104,
  "cloudversify": 62341,
  "usps": 63457,
  "megaport": 62883,
  "magento": 62404,
  "spotify": 61884,
  "optin-monster": 62012,
  "fly": 62487,
  "aviato": 62497,
  "itunes": 62388,
  "cuttlefish": 62348,
  "blogger": 62332,
  "flickr": 61806,
  "viber": 62473,
  "soundcloud": 61886,
  "digg": 61862,
  "tencent-weibo": 61909,
  "letterboxd": 58925,
  "symfony": 63549,
  "maxcdn": 61750,
  "etsy": 62167,
  "facebook-messenger": 62367,
  "audible": 62323,
  "think-peaks": 63281,
  "bilibili": 58329,
  "erlang": 62365,
  "x-twitter": 58907,
  "cotton-bureau": 63646,
  "dashcube": 61968,
  "42-group": 57472,
  "innosoft": 57472,
  "stack-exchange": 61837,
  "elementor": 62512,
  "square-pied-piper": 57374,
  "pied-piper-square": 57374,
  "creative-commons-nd": 62699,
  "palfed": 62424,
  "superpowers": 62173,
  "resolving": 62439,
  "xbox": 62482,
  "square-web-awesome-stroke": 59012,
  "searchengin": 62443,
  "tiktok": 57467,
  "square-facebook": 61570,
  "facebook-square": 61570,
  "renren": 61835,
  "linux": 61820,
  "glide": 62117,
  "linkedin": 61580,
  "hubspot": 62386,
  "deploydog": 62350,
  "twitch": 61928,
  "flutter": 59028,
  "ravelry": 62169,
  "mixer": 57430,
  "square-lastfm": 61955,
  "lastfm-square": 61955,
  "vimeo": 62474,
  "mendeley": 63411,
  "uniregistry": 62468,
  "figma": 63385,
  "creative-commons-remix": 62702,
  "cc-amazon-pay": 62509,
  "dropbox": 61803,
  "instagram": 61805,
  "cmplid": 58208,
  "upwork": 58945,
  "facebook": 61594,
  "gripfire": 62380,
  "jedi-order": 62734,
  "uikit": 62467,
  "fort-awesome-alt": 62371,
  "phabricator": 62427,
  "ussunnah": 62471,
  "earlybirds": 62362,
  "trade-federation": 62739,
  "autoprefixer": 62492,
  "whatsapp": 62002,
  "square-upwork": 59004,
  "slideshare": 61927,
  "google-play": 62379,
  "viadeo": 62121,
  "line": 62400,
  "google-drive": 62378,
  "servicestack": 62444,
  "simplybuilt": 61973,
  "bitbucket": 61809,
  "imdb": 62168,
  "deezer": 57463,
  "raspberry-pi": 63419,
  "jira": 63409,
  "docker": 62357,
  "screenpal": 58736,
  "bluetooth": 62099,
  "gitter": 62502,
  "d-and-d": 62349,
  "microblog": 57370,
  "cc-diners-club": 62028,
  "gg-circle": 62049,
  "pied-piper-hat": 62693,
  "kickstarter-k": 62396,
  "yandex": 62483,
  "readme": 62677,
  "html5": 61755,
  "sellsy": 61971,
  "square-web-awesome": 59011,
  "sass": 62494,
  "wirsindhandwerk": 58064,
  "wsh": 58064,
  "buromobelexperte": 62335,
  "salesforce": 63547,
  "octopus-deploy": 57474,
  "medapps": 62406,
  "ns8": 62421,
  "pinterest-p": 62001,
  "apper": 62321,
  "fort-awesome": 62086,
  "waze": 63551,
  "bluesky": 58993,
  "cc-jcb": 62027,
  "snapchat": 62123,
  "snapchat-ghost": 62123,
  "fantasy-flight-games": 63196,
  "rust": 57466,
  "wix": 62927,
  "square-behance": 61877,
  "behance-square": 61877,
  "supple": 62457,
  "webflow": 58972,
  "rebel": 61904,
  "css3": 61756,
  "staylinked": 62453,
  "kaggle": 62970,
  "space-awesome": 58796,
  "deviantart": 61885,
  "cpanel": 62344,
  "goodreads-g": 62377,
  "square-git": 61906,
  "git-square": 61906,
  "square-tumblr": 61812,
  "tumblr-square": 61812,
  "trello": 61825,
  "creative-commons-nc-jp": 62698,
  "get-pocket": 62053,
  "perbyte": 57475,
  "grunt": 62381,
  "weebly": 62924,
  "connectdevelop": 61966,
  "leanpub": 61970,
  "black-tie": 62078,
  "themeco": 62918,
  "python": 62434,
  "android": 61819,
  "bots": 58176,
  "free-code-camp": 62149,
  "hornbill": 62866,
  "js": 62392,
  "ideal": 57363,
  "git": 61907,
  "dev": 63180,
  "sketch": 63430,
  "yandex-international": 62484,
  "cc-amex": 61939,
  "uber": 62466,
  "github": 61595,
  "php": 62551,
  "alipay": 63042,
  "youtube": 61799,
  "skyatlas": 61974,
  "firefox-browser": 57351,
  "replyd": 62438,
  "suse": 63446,
  "jenkins": 62390,
  "twitter": 61593,
  "rockrms": 62441,
  "pinterest": 61650,
  "buffer": 63543,
  "npm": 62420,
  "yammer": 63552,
  "btc": 61786,
  "dribbble": 61821,
  "stumbleupon-circle": 61859,
  "internet-explorer": 62059,
  "stubber": 58823,
  "telegram": 62150,
  "telegram-plane": 62150,
  "old-republic": 62736,
  "odysee": 58822,
  "square-whatsapp": 62476,
  "whatsapp-square": 62476,
  "node-js": 62419,
  "edge-legacy": 57464,
  "slack": 61848,
  "slack-hash": 61848,
  "medrt": 62408,
  "usb": 62087,
  "tumblr": 61811,
  "vaadin": 62472,
  "quora": 62148,
  "square-x-twitter": 58906,
  "reacteurope": 63325,
  "medium": 62010,
  "medium-m": 62010,
  "amilia": 62317,
  "mixcloud": 62089,
  "flipboard": 62541,
  "viacoin": 62007,
  "critical-role": 63177,
  "sitrox": 58442,
  "discourse": 62355,
  "joomla": 61866,
  "mastodon": 62710,
  "airbnb": 63540,
  "wolf-pack-battalion": 62740,
  "buy-n-large": 63654,
  "gulp": 62382,
  "creative-commons-sampling-plus": 62705,
  "strava": 62504,
  "ember": 62499,
  "canadian-maple-leaf": 63365,
  "teamspeak": 62713,
  "pushed": 62433,
  "wordpress-simple": 62481,
  "nutritionix": 62422,
  "wodu": 57480,
  "google-pay": 57465,
  "intercom": 63407,
  "zhihu": 63039,
  "korvue": 62511,
  "pix": 58426,
  "steam-symbol": 62454
}